import type {Criterion, CriterionField, Matcher} from '../criteria.types';

export interface BetweenCriterionHack {
    from: any;
    to: any;
}

export default class BetweenCriterion implements Criterion {
    public value: { from: null; to: null };

    constructor(public field: CriterionField, matcher?: BetweenCriterionHack) {
        this.value = {
            from: matcher ? matcher.from : null,
            to: matcher ? matcher.to : null
        };
    }

    public clear() {
        this.value.from = null;
        this.value.to = null;
    }

    public isEmpty() {
        return !this.value.from && !this.value.to;
    }

    public toMatcher(): Matcher {
        return {
            between: {
                from: this.value.from,
                to: this.value.to
            }
        };
    }
}
